import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import '@/App.css';
import Landing from './pages/Landing';
import Auth from './pages/Auth';
import Dashboard from './pages/Dashboard';
import NewReading from './pages/NewReading';
import DailyReading from './pages/DailyReading';
import ReadingDetail from './pages/ReadingDetail';
import Encyclopedia from './pages/Encyclopedia';
import Premium from './pages/Premium';
import PremiumSuccess from './pages/PremiumSuccess';
import SharedReading from './pages/SharedReading';
import AdminDashboard from './pages/AdminDashboard';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
export const API = `${BACKEND_URL}/api`;

axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    localStorage.removeItem('seatask-language');
    document.documentElement.removeAttribute('data-seatask-translated');
    document.cookie = 'googtrans=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
    document.cookie = 'googtrans=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.seatask.io';
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');

    if (token && userData) {
      setIsAuthenticated(true);
      setUser(JSON.parse(userData));
    }
    setLoading(false);
  }, []);

  const handleLogin = (token, userData) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userData));
    setIsAuthenticated(true);
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setIsAuthenticated(false);
    setUser(null);
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <div className="text-[#D4AF37] text-xl font-heading">Loading...</div>
      </div>
    );
  }

  const protect = (Component) =>
    isAuthenticated ? <Component user={user} onLogout={handleLogout} /> : <Navigate to="/auth" />;

  const protectAdmin = () => {
    if (!isAuthenticated) return <Navigate to="/auth" />;
    return user?.role === 'admin'
      ? <AdminDashboard user={user} onLogout={handleLogout} />
      : <Navigate to="/dashboard" />;
  };

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/share/:shareId" element={<SharedReading />} />
          <Route
            path="/auth"
            element={isAuthenticated ? <Navigate to={user?.role === 'admin' ? '/admin' : '/dashboard'} /> : <Auth onLogin={handleLogin} />}
          />
          <Route path="/login" element={<Navigate to="/auth" />} />
          <Route path="/register" element={<Navigate to="/auth" />} />
          <Route path="/dashboard" element={user?.role === 'admin' ? <Navigate to="/admin" /> : protect(Dashboard)} />
          <Route path="/admin" element={protectAdmin()} />
          <Route path="/reading/new" element={protect(NewReading)} />
          <Route path="/reading/daily" element={protect(DailyReading)} />
          <Route path="/reading/:id" element={protect(ReadingDetail)} />
          <Route path="/encyclopedia" element={protect(Encyclopedia)} />
          <Route path="/premium" element={protect(Premium)} />
          <Route path="/premium/success" element={protect(PremiumSuccess)} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
